import { createApp } from "vue";
import App from "./App.vue";
/*
TIP: To get started with clean router change path to @/router/clean.ts.
 */
import router from "./router";
import store from "./store";
import { createPinia } from "pinia";
import ElementPlus from "element-plus";
import i18n from "@/core/plugins/i18n";

//imports for app initialization
import ApiService from "@/core/services/ApiService";
import { initApexCharts } from "@/core/plugins/apexcharts";
import { initInlineSvg } from "@/core/plugins/inline-svg";
import { initVeeValidate } from "@/core/plugins/vee-validate";
import ru from "@/locales/element-plus/ru";

import "@/core/plugins/prismjs";
import "bootstrap";
import "./assets/css/main.css";
import "./assets/css/report.css";
import "@imengyu/vue3-context-menu/lib/vue3-context-menu.css";

const app = createApp(App);
const pinia = createPinia();

app.use(store);
app.use(pinia);
app.use(router);
app.use(ElementPlus, {
  size: "medium", // Здесь вы можете установить размер элементов по умолчанию
  zIndex: 1000, // Здесь вы можете установить начальное значение zIndex
  locale: ru,
});

(async () => {
  try {
    await ApiService.init(app); //API promises
  } catch {
    // The response interceptor selects the authentication or error route.
  }
  // the rest of the code

  initApexCharts(app);
  initInlineSvg(app);
  initVeeValidate();

  app.use(i18n);

  app.mount("#app");
})();
